import { ReactElement, useEffect, useRef } from 'react'
import { embedDashboard, EmbeddedDashboard } from '@superset-ui/embedded-sdk'
import { fetchSuperSetGuestToken } from '../../services/userServices'
import { Box } from '@mui/material'
import { useAppSelector } from '../../redux/hook'

interface ISupersetDashboard {
    dashboardId: string
}

const SupersetDashboard = (props: ISupersetDashboard): ReactElement => {
    const { dashboardId } = props
    const org = useAppSelector((state) => state.org.org)
    const supersetDomain = import.meta.env.VITE_SUPERSET_DOMAIN || ''
    const dashboardContainerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        let embeddedDasboardInstance: EmbeddedDashboard
        const embedSupersetDashboard = async () => {
            embeddedDasboardInstance = await embedDashboard({
                id: dashboardId,
                supersetDomain,
                mountPoint: dashboardContainerRef.current as HTMLDivElement,
                fetchGuestToken: () =>
                    fetchSuperSetGuestToken(dashboardId, org?.id || ''),
                dashboardUiConfig: {
                    hideChartControls: false,
                    hideTitle: true,
                    filters: {
                        expanded: false,
                    },
                },
            })
        }

        embedSupersetDashboard()

        return () => {
            if (embeddedDasboardInstance) {
                embeddedDasboardInstance.unmount()
            }
        }
    }, [dashboardId, org, supersetDomain])

    return (
        <Box
            ref={dashboardContainerRef}
            id="dashboard-container"
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
            }}
        />
    )
}

export default SupersetDashboard
